export const of_shipping_instructions_displayed_columns_locale = {
  billOfLadingType: "Bill of lading",
  numberOfOriginals: "# of originals",
  numberOfCopies: "# of copies",
  numberOfContainers: "# of containers",
  portOfLoading: "Port of loading",
  portOfDischarge: "Port of discharge",
  status: "Status"
};
